module.exports = __webpack_public_path__ + "media/images/icons/like-2-8ae67021ea4876b9952278b9b5d0bd87.svg";